module.exports = __webpack_public_path__ + "img/csfw.6a1c7f3a.png";